import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';

@Injectable({
  providedIn: 'root',
})
export class RSAHelper {
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgH1cMZvh0giAWGyNXWXWEH89Gyc9
  yohfzZ2LkCNEuBKWNboue551PTa76r3SQ6cBSZarJhR6NAYGVcAx+89/uPZ7EToE
  oj0MlegOoiZtZfJlGuvaOPwD+JpSMU7mizgSa/ZqwLmiNfGvnM5+S8YRz6a4ulNA
  JM0GbV7k38RFvMJHAgMBAAE=
  -----END PUBLIC KEY-----`;

  constructor() {}

  encryptWithPublicKey(valueToEncrypt: string): string {
    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }
}
